import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const buildAddAddClauseToEndorsement = function(errorHandler) {
	return async function({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addAddClauseToEndorsement(
				$policyId: String!
				$endorsementId: String
				$input: addClauseInput!
			) {
				addAddClauseToEndorsement(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addAddClauseToEndorsement, store)
		return {
			status: res?.data?.addAddClauseToEndorsement?.status,
			id: res?.data?.addAddClauseToEndorsement?.createdStatus?.id
		}
	}
}

const buildAddClauseToPolicy = function(errorHandler) {
	return async function({ policyId, input, store }) {
		const query = gql`
			mutation addClauseToPolicy($policyId: String!, $input: addClauseInput!) {
				addClauseToPolicy(policyId: $policyId, input: $input) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addClauseToPolicy, store)
		return {
			status: res?.data?.addClauseToPolicy?.status,
			id: res?.data?.addClauseToPolicy?.createdStatus?.id
		}
	}
}

const buildUpdateClauseOfPolicy = function(errorHandler) {
	return async function({ policyId, input, clauseId, store }) {
		const query = gql`
			mutation updateClauseOfPolicy(
				$policyId: String!
				$input: updateClauseInput!
				$clauseId: String!
			) {
				updateClauseOfPolicy(
					policyId: $policyId
					input: $input
					clauseId: $clauseId
				) {
					errors
					status
				}
			}
		`
		const variables = { policyId, input, clauseId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateClauseOfPolicy, store)
		return {
			status: res?.data?.updateClauseOfPolicy?.status,
			id: res?.data?.updateClauseOfPolicy?.createdStatus?.id
		}
	}
}

const buildRemoveClauseFromPolicy = function(errorHandler) {
	return async function({ policyId, clauseId, store }) {
		const query = gql`
			mutation removeClauseFromPolicy($policyId: String!, $clauseId: String!) {
				removeClauseFromPolicy(policyId: $policyId, clauseId: $clauseId) {
					errors
					status
				}
			}
		`
		const variables = { policyId, clauseId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeClauseFromPolicy, store)
		return {
			status: res?.data?.removeClauseFromPolicy?.status,
			id: res?.data?.removeClauseFromPolicy?.createdStatus?.id
		}
	}
}

export {
	buildAddAddClauseToEndorsement,
	buildAddClauseToPolicy,
	buildRemoveClauseFromPolicy,
	buildUpdateClauseOfPolicy
}
